import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";
import { Observable } from "rxjs";
import { AuthenticationService } from "@app/core/services/authentication.service";
import { AppInjector } from "@app/core/functions/app-injector";
import { TabService } from "@app/core/services/tab.service";
import { UserSettingsService } from "@app/core/services/user-settings.service";
import { APPLICATIONS } from "@app/shared/constants/applications.constants";
import { I18nService } from "@app/core/services/i18n.service";
import { GLH_WS } from "@app/portals/glh-modules/glh-shared/constants/url.constants";
import { ILH_WS } from "@app/portals/ilh-modules/ilh-shared/constants/url.constants";
import { WC_WS } from "@app/portals/wc-modules/wc-shared/constants/url.constants";

/**
 * Transforms all ussi responses
 */
@Injectable({
  providedIn: "root"
})
export class RequestInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const modifiedRequest: HttpRequest<any> = request.clone({
      setHeaders: {
        Token: `${this._authService.token}`,
        Language: `${this._userSettingsService?.language ?? this._i18nService.language}`,
        Appid: this._setApplicationId(request.url)
      }
    });
    return next.handle(modifiedRequest);
  }

  /**
   * Inject authentication service at runtime
   */
  private get _authService(): AuthenticationService {
    return AppInjector.get(AuthenticationService);
  }

  /**
   * Inject user settings service at runtime
   */
  private get _userSettingsService(): UserSettingsService {
    return AppInjector.get(UserSettingsService);
  }

  /**
   * Inject user settings service at runtime
   */
  private get _i18nService(): I18nService {
    return AppInjector.get(I18nService);
  }

  /**
   * Inject tab service service at runtime
   */
  private get _tabService(): TabService {
    return AppInjector.get(TabService);
  }

  /**
   * Set application id based on end point or specific account types like admin
   * @param url
   * @returns
   */
  private _setApplicationId(url: string): string {
    if (!url) {
      return APPLICATIONS.CORE;
    }

    if (this._authService.isAdmin) {
      return APPLICATIONS.ADMIN;
    }

    if (url.includes(GLH_WS.glh)) {
      return APPLICATIONS.GROUP;
    }

    if (url.includes(ILH_WS.ilh)) {
      return APPLICATIONS.INDIVIDUAL;
    }

    if (url.includes(WC_WS.wc)) {
      return APPLICATIONS.WC;
    }

    // Return tab app id if it exists
    // or fallback to core for IPLUS, RPLUS, DPLUS, or anything else
    return this._tabService.activeMenuOptionApplication ?? APPLICATIONS.CORE;
  }
}
